import { getMatchDetailLabel } from "./matchDetails";

export function getMatchDisplayDetails(match: { venue?: string | null; commentator?: string | null }) {
  return {
    venue: getMatchDetailLabel(match.venue),
    commentator: getMatchDetailLabel(match.commentator),
  };
}
